/**
 * 共享素材控制器，需要继承素材库主控制器
 */
'use strict';

angular.module('resourceCenterMaterialModule').controller('shareMaterialCtrl', [
    '$scope',
    '$controller',
    'mrApiService',
    '$q',
    'modalDialog',
    '$stateParams',
    '$element',
    '$compile',
    'globleParamsSet',
    'localStorageService',
    '$sessionStorage',
    function ($scope, $controller, mrApiService, $q, modalDialog, $stateParams, $element, $compile, globleParamsSet, localStorageService, $sessionStorage) {
        // eslint-disable-next-line no-unused-vars
        initScope();
        initStatus();
        initData();

        /**
         * [initScope 初始化作用域，继承素材库主控制器]
         *
         * @return  {[type]}          [return description]
         */
        function initScope() {
            let vm = this || window;
            let parentCtr = $controller('resCenterMRRelCtrl', { $scope: $scope, mrApiService: mrApiService, $q: $q, });
            vm = angular.extend(vm, parentCtr);
        }

        /**
         * [initScope 初始化状态]
         *
         * @return  {[type]}          [return description]
         */
        function initStatus() {
            $scope.title = '共享素材页面';
            $scope.basicalStatus.commonParams.mrType = 'share';
            $scope.basicalStatus.commonParams.mainResourceType = $stateParams.resourcetype;
            $scope.basicalStatus.buttonCheck.name = 'sharedmaterial';
            $scope.basicalStatus.buttonCheck.ModalName = '共享素材库';
        }

        /**
         * [initScope 初始化数据]
         *
         * @return  {[type]}          [return description]
         */
        function initData() {
            $scope.requestData();
            initMessageChange();
        }

        // TODO 提取为公共方法
        /**
         * [initScope 初始化信息编辑组件]
         *
         * @return  {[type]}          [return description]
         */
        function initMessageChange() {
            var message = '<message-change></message-change>';
            message = $compile(message)($scope);
            $element.find('messageChange').append(message);
        }

    },
]);
